module.exports = __webpack_public_path__ + "media/images/lb/206-e3e91544857d11d6ab777f3e9470a0c1.svg";